// Direction B "Ink Header" footer. Mono uppercase 10px / 0.16em tracking
// "POWERED BY" eyebrow, followed by the "mikla.ai" wordmark rendered as
// real text per co-founder spec:
//   - "mikla" + "ai" in Plus Jakarta Sans Bold (700)
//   - "." (period) in Inter Regular, color #ff0041 (token: text-accent) —
//     Plus Jakarta's period glyph is square; Inter's is round, which is the
//     intended visual for the wordmark.
//
// Why text instead of the PNG logo: at small footer sizes, a rasterized
// wordmark never quite snaps onto the same baseline as the surrounding
// "POWERED BY" eyebrow (the PNG box bounds and the font's baseline metrics
// are unrelated). Real text shares the same baseline grid as the eyebrow,
// so alignment is automatic at any size + DPR. Bonus: zero bundle hit (the
// two webfonts load async outside the JS bundle), and the wordmark scales
// crisply if the design ever wants a bigger or smaller treatment.
//
// Outbound link still goes to mikla.ai with the existing UTM tags so the
// referral attribution survives the visual refresh. Per spec sec 9 the link
// is the affordance — the footer copy itself is a soft brand badge, not a
// promotional callout.

export function PoweredByMikla() {
  return (
    <div
      data-testid="powered-by-mikla"
      className="flex-shrink-0 bg-paper border-t border-border-muted text-center pt-2 pb-[11px]"
    >
      <a
        href="https://mikla.ai/?ref=widget&utm_source=widget&utm_medium=referral"
        target="_blank"
        rel="noopener noreferrer ugc"
        className="inline-flex items-baseline justify-center gap-2 hover:opacity-90 transition-opacity"
      >
        <span className="font-mono text-[10px] font-medium uppercase tracking-eyebrow text-muted-400">
          Powered by
        </span>
        {/* Wordmark sized at 14px so its x-height sits right above the 10px
            eyebrow's cap height — anchored but quiet (chat-widget convention).
            items-baseline on the parent keeps the wordmark's baseline + the
            eyebrow's baseline locked together regardless of font load order. */}
        <span className="font-jakarta font-bold text-[14px] leading-none text-ink tracking-[-0.01em]">
          mikla<span className="font-inter text-accent">.</span>ai
        </span>
      </a>
    </div>
  )
}
